import React, { useState, useEffect } from 'react';
import Item from '../Statistics/Item';
import axios from '../../../util/Api';

const TotalCount = () => {
  const [loading, setLoading] = useState(true);
  const [count, setCount] = useState(null);

  useEffect(() => {
    setLoading(true);
    const url = `/passport/count`;
    axios.get(url).then(resp => {
      setCount(resp.data);
      setLoading(false);
    }).catch(err=>{});
  }, []);
  return (
    <Item label={`Personel Terdaftar`} value={count} loading={loading} />
  );
}

export default TotalCount;